'use es6';

export const identity = value => value;